import Add from './add.vue'

export default [{
    path: '/:type',
    name:'empAdd',
    component:Add,
}]